import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { BUTTON_SIZES, Button } from 'ui/button';
import { Truncate } from 'ui/utility/truncate';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { colors, spacing } from 'ui/theme';

const filterSegmentBackgroundStyle = (props: FilterSegmentProps) => {
  if (props.isDisabled) return colors.backgroundSecondary;
  if (props.isToggled) return colors.white;
  return colors.purple10;
};

const StyledButton = styled(Button)`
  &&& {
    background: ${(props: FilterSegmentProps) => filterSegmentBackgroundStyle(props)};
    border: ${(props: { isToggled?: boolean }) =>
      props.isToggled
        ? `${spacing.single} solid ${colors.purple50}`
        : `${spacing.single} solid transparent`};
    color: ${(props: { isDisabled?: boolean }) =>
      props.isDisabled ? colors.secondaryText : colors.purple90};

    box-shadow: none;
    &:hover {
      border: ${spacing.single} solid ${colors.purple50};
    }
  }
`;

type FilterSegmentProps = {
  onClick: () => void;
  isToggled?: boolean;
  'data-test'?: string;
  isDisabled?: boolean;
};

export const FilterSegmentButton: React.FC<React.PropsWithChildren<FilterSegmentProps>> = ({
  children,
  ...props
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (ref?.current?.offsetWidth && ref?.current?.offsetWidth < ref?.current?.scrollWidth) {
      setIsTruncated(true);
    }
  });
  return (
    <Tooltip isEnabled={isTruncated} tooltipContent={children}>
      <StyledButton size={BUTTON_SIZES.LARGE} {...props}>
        <Truncate maxWidth={168} ref={ref}>
          {children}
        </Truncate>
      </StyledButton>
    </Tooltip>
  );
};
